import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { styled } from '@linaria/react';
import { Button } from '@livecommerce/design-system';
import { Heading, Container, Description } from 'pages/UnauthorizedPage/styles.js';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const CenteredError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1;
  width: 400px;
`;

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { t } = useLocalization();

  useEffect(() => {
    console.log('error', error);

    Sentry.captureException(error);
  }, [error]);

  const handleClick = useCallback(() => {
    resetErrorBoundary();
  }, [resetErrorBoundary]);

  return (
    <Container>
      <CenteredError>
        <Heading>{t('errorFallbackPage.heading')}</Heading>
        <Description>{t('errorFallbackPage.description')}</Description>
        <Button variant="solid" onClick={handleClick}>
          {t('errorFallbackPage.reloadPageButtonLabel')}
        </Button>
      </CenteredError>
    </Container>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.object.isRequired,
  resetErrorBoundary: PropTypes.func.isRequired,
};

export default ErrorFallback;
